import { Box, FormHelperText, Grid } from "@material-ui/core";
import { useField } from "formik";
import React from "react";

const EntryColor = ({
  label,
  name,
  placeholder,
  InputProps,
  // ...
  sx,
  // ...
  xs = 12,
  md = 6
}) => {
  const [field, meta, helpers] = useField({ name });
  // ...
  return (
    <Grid item xs={xs} md={md}>
      <div className="EntryColor">
        <label className="EntryColor__label">{label}</label>
        <div
          className="EntryColor__preview"
          style={{
            backgroundColor: field?.value || ""
          }}
        />
        <div className="EntryColor__value">{field?.value || "#ffffff"}</div>
        <Box
          component="input"
          type="color"
          name={name}
          aria-label={label}
          placeholder={placeholder}
          value={field?.value || "#ffffff"}
          onChange={(event) => helpers.setValue(event.target.value)}
          onBlur={field.onBlur}
          className="EntryColor__input"
          sx={{
            width: "100%",
            height: 56,
            borderRadius: 8,
            border: "1px solid rgba(145, 158, 171, 0.32)",
            cursor: "pointer",
            p: 0,
            backgroundColor: "transparent",
            ...sx,
          }}
          {...(InputProps?.inputProps || {})}
        />
        {meta.touched && meta.error ? (
          <FormHelperText error>{meta.error}</FormHelperText>
        ) : null}
      </div>
    </Grid>
  );
};

export default EntryColor;
